<template>
    <main>
        <h2 class="page-title">Admin</h2>
        <nav>
            <ul class="admin-page-links">
                <li v-for="(permalink, name) in getPermalinks" class="animate__animated animate__fadeIn">
                    <a v-bind:href="permalink">
                    Manage {{ name }}
                    </a>
                </li>
            </ul>
        </nav>
          
    </main>
</template>

<style>
    .admin-page-links {
    display: flex;
    justify-content: space-evenly;
    padding: 20px;
    font-size: 25px;
    list-style: none;
    }
  .admin-page-links li {
    background-color: #765d9f;
    text-align: center;
    width: calc(100%/3 - 8rem);
    height: 100px;
    line-height: 100px;
  }
    .admin-page-links li:hover{
        box-shadow: 2px 2px 2px 2px rgb(186, 172, 195);
        transition: 0.3s;
    } 
    .admin-page-links a {
        color: black;
        text-decoration: none;
    }
    @media only screen and (max-width: 1020px) {
    .admin-page-links {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .admin-page-links li {
    width: 60%;
    height: auto;
    margin: 1rem
  }
    }
    @media only screen and (max-width: 400px) {
    .admin-page-links li {
        height: 70px;
        line-height: normal;
        padding: 10px 0
  } 
    }
</style>

<script>
import 'animate.css';

export default {
    data(){
        return {
        }
    },
    props: {
        teamId: {
        type: String,
        required: true
        }
  },
  mounted() {
        this.$teamService.getPermalinksForTeam(this.teamId)

  },
  computed: {
    getPermalinks() {
        return this.$teamService.permalinks
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue